import { IBuildType } from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import caseInsensitiveSort from "../../../../../tools/common/caseInsensitiveSort";

export const getBuildTypeOptions = (
  t: UseTranslateResult["t"],
  buildTypes?: IBuildType[]
) => {
  if (!buildTypes?.length) {
    return [{ value: "", label: t("global.sign_up.no_build_types") }];
  }
  const sorted = caseInsensitiveSort(buildTypes, "name");
  return sorted.map(({ name, id }) => ({ value: id, label: name }));
};
